
import { CONSTANTS } from "../../utilities/Dimensions";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
  maxSize,
  minSize,
} from "rn-responsive-styles";


const useStyles = CreateResponsiveStyle(
  {
    container: {
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#ffffff",
      flexDirection: "row",
      borderRadius: 15,
      paddingVertical: 10,
      paddingHorizontal: 20,
      marginBottom: 20,
    },
    contentWrapper:{
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      flex: 1,
      marginHorizontal: 30,
    },
    defImg:{ 
      width: 60, 
      height: 60, 
      borderRadius: 50, 
      marginRight: 10 
    },
    globalName: {
      fontFamily: "Inter",
      fontSize: 26,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 36,
      letterSpacing: 0,
      textAlign: "left",
      color: "#66625f",
      paddingTop: 15,
      paddingLeft: 10,
    },
    headerViewContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
    },

    headerFirstViewSTyle: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      flex: 1,
      marginHorizontal: 30,
    },

    hamburgerIconStyle: {
      width: 30,
      height: 26,
    },

    headerSecondViewStyle: {
      flexDirection: "row",
    },

    headerProfileImageStyle: {
      height: 70,
      width: 70,
      resizeMode: "center",
    },

    headerThirdViewStyle: {
      alignItems: "flex-start",
      justifyContent: "center",
    },

    headerUserNameTextStyle: {
      fontFamily: "Inter",
      fontSize: 26,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 36,
      letterSpacing: 0,
      textAlign: "left",
      color: "#ffffff",
    },

    retailsTextStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 22,
      letterSpacing: 0,
      textAlign: "left",
      color: "#ffffff",
    },

    headerAddVehViewStyle: {
      marginRight: 20,
      alignItems: "center",
      justifyContent: "center",
      width: 149,
      height: 31,
      borderStyle: "solid",
      borderWidth: 2,
      borderColor: "#ffffff",
      borderRadius: 20,
      flexDirection: "row",
    },

    headerAddVehImageStyle: {
      width: 28,
      hieght: 18,
      resizeMode: "center",
    },

    headerAddvehTextStyle: {
      fontFamily: "Inter",
      fontSize: CONSTANTS.PROFILE_TEXT_WIDTH,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: CONSTANTS.PROFILE_TEXT_WIDTH,
      letterSpacing: 0,
      textAlign: "center",
      color: "#ffffff",
    },

    headerFastagStatusTxtStyle: {
      fontFamily: "Inter",
      fontSize: CONSTANTS.PROFILE_TEXT_WIDTH,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: CONSTANTS.PROFILE_TEXT_WIDTH,
      letterSpacing: 0,
      textAlign: "center",
      color: "#ffffff",
      paddingTop: 5,
    },

    tabViewAddvehViewStyle: {
      marginRight: 20,
      alignItems: "center",
      justifyContent: "center",
    },

    tabViewAddVehTxtStyle: {
      fontFamily: "Inter",
      fontSize: CONSTANTS.PROFILE_TEXT_WIDTH,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: CONSTANTS.PROFILE_TEXT_WIDTH,
      letterSpacing: 0,
      textAlign: "center",
      color: "#ffffff",
    },

    fastagStatusTxtStyle: {
      fontFamily: "Inter",
      fontSize: CONSTANTS.PROFILE_TEXT_WIDTH,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: CONSTANTS.PROFILE_TEXT_WIDTH,
      letterSpacing: 0,
      textAlign: "center",
      color: "#ffffff",
    },

    userNameTxtStyle: {
      fontFamily: "Inter",
      fontSize: 26,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 36,
      letterSpacing: 0,
      textAlign: "left",
      color: "#66625f",
      paddingTop: 15,
    },

    profileImageStyle: {
      height: 85,
      width: 85,
      resizeMode: "center",
    },

    addVehicleButtonStyle: {
      width: "20%",
      height: 48,
      borderRadius: 27,
      borderStyle: "solid",
      borderWidth: 2,
      borderColor: "#bd2d37",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    },

    addVehicleImageStyle: {
      width: 40,
      height: 30,
      resizeMode: "center",
    },

    addVehicleTextStyle: {
      fontFamily: "Inter",
      fontSize: CONSTANTS.PROFILE_TEXT_WIDTH,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 23,
      letterSpacing: 0.38,
      textAlign: "center",
      color: "#bd2d37",
      paddingLeft: 15,
    },

    fastagTxtStyle: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 24,
      letterSpacing: 0,
      textAlign: "right",
      color: "#66625f",
    },

    fastagIdStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 29,
      letterSpacing: 0,
      textAlign: "left",
      color: "#66625f",
    },

    trackAllButtonStyle: {
      width: 87.6,
      height: 22.3,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#cccccc",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 5,
      alignSelf: "flex-end",
    },

    trackAllTextStyle: {
      fontFamily: "Inter",
      fontSize: 11,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 22,
      letterSpacing: 0,
      textAlign: "left",
    },
    updateKycImg:{
      height: 48,
      width: 219,
      paddingHorizontal: 10,
      borderRadius: 27,
      borderStyle: "solid",
      borderWidth: 2,
      borderColor: "#bd2d37",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      marginLeft: 70,
      marginRight: 10
    },
    addVehImg:{
      height: 48,
      width: 219,
      paddingHorizontal: 10,
      borderRadius: 27,
      borderStyle: "solid",
      borderWidth: 2,
      borderColor: "#bd2d37",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    },
    addVevIcon:{
      marginRight: 20,
      alignItems: "center",
      justifyContent: "center",
      width: 149,
      height: 31,
      borderStyle: "solid",
      borderWidth: 2,
      borderColor: "#ffffff",
      borderRadius: 20,
      flexDirection: "row",
    },
  },

  {
    [maxSize(DEVICE_SIZES.SM)]: {
      headerProfileImageStyle: {
        height: 100,
        width: 100,
      },
      globalName: {
        fontSize: 13,
        lineHeight: 24,
      },
      headerUserNameTextStyle: {
        fontSize: 16,
        lineHeight: 22,
      },

      retailsTextStyle: {
        fontSize: 10,
        lineHeight: 11,
      },

      headerAddvehTextStyle: {
        fontSize: 13,
        lineHeight: 25,
      },

      headerFastagStatusTxtStyle: {
        fontSize: 9,
        lineHeight: 13,
      },

      tabViewAddVehTxtStyle: {
        fontSize: 13,
        lineHeight: 25,
      },

      fastagStatusTxtStyle: {
        fontSize: 9,
        lineHeight: 13,
      },
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},

    [DEVICE_SIZES.XS]: {
      globalName: {
        fontSize: 13,
        lineHeight: 24,
      },

    }
  }
);

export default useStyles;